const $ = window.jQuery

// https://getbootstrap.com/docs/5.3/getting-started/javascript/
// require('bootstrap/js/dist/modal.js')
// import ScrollSpy from 'bootstrap/js/dist/scrollspy'
import Modal from 'bootstrap/js/dist/modal'

import Tabs from 'bootstrap/js/dist/tab'

import { debounce, throttle } from 'lodash';

import appUtils from './modules/app_utils'
import carousel from './modules/carousel'
import carouselAction from './modules/carousel_action'
import svgInline from './modules/svg_inline'

import search from './modules/search';

//ie8 bugfix. using get or load method fonnt-face is broken immediately after new items are added                
(function( jQuery ) {
  jQuery.fn.getLoad = function(url, selector, data, loadCallback) {
      var box=this, items;
      jQuery.get(url , data, function(responseText, textStatus, XMLHttpRequest){
          if(selector){
              items=jQuery(responseText).find(selector);
          }else{
              items=jQuery(responseText);
          }
          box.html(items);
          if(loadCallback) {loadCallback(responseText, textStatus, XMLHttpRequest, items);}
      });
      return this;
  };
  jQuery.fn.postLoad = function(url, selector, data, loadCallback) {
      var box=this, items;
      jQuery.post(url , data, function(responseText, textStatus, XMLHttpRequest){
          if(selector){
              items=jQuery(responseText).find(selector);
          }else{
              items=jQuery(responseText);
          }
          box.html(items);
          if(loadCallback) {loadCallback(responseText, textStatus, XMLHttpRequest, items);}
      });
      return this;
  };
  jQuery.fn.postAppend = function(url, selector, data, loadCallback) {
      var box=this, items;
      jQuery.post(url , data, function(responseText, textStatus, XMLHttpRequest){
          if(selector){
              items=jQuery(responseText).find(selector);
          }else{
              items=jQuery(responseText);
          }
          box.append(items);
          if(loadCallback) {loadCallback(responseText, textStatus, XMLHttpRequest, items);}
      });
      return this;
  };
  jQuery.fn.postPrepend = function(url, selector, data, loadCallback) {
      var box=this, items;
      jQuery.post(url , data, function(responseText, textStatus, XMLHttpRequest){
          if(selector){
              items=jQuery(responseText).find(selector);
          }else{
              items=jQuery(responseText);
          }
          box.prepend(items);
          if(loadCallback) {loadCallback(responseText, textStatus, XMLHttpRequest, items);}
      });
      return this;
  };
  
})( jQuery );


  

  
const onDocumentReady = function() {
  
  /*
  * my-favoritest plugin buttons accessibiltiy
  */
  const buttons = document.querySelectorAll('.ccc-favorite-post-toggle-button');
  function updateAriaAttributes(button) {
      const isSaved = button.classList.contains('save');
      button.setAttribute('aria-pressed', isSaved ? "true" : "false");
      button.setAttribute('aria-label', isSaved ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti");
      const textSpan = button.querySelector('.text');
      if (textSpan) {
        textSpan.textContent = isSaved ? "Salvato" : "Salva";
      }
  }
  // Observer creation for each button
  buttons.forEach(button => {
      // Initial state syncronization
      updateAriaAttributes(button);
      const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
              if (mutation.attributeName === "class") {
                  updateAriaAttributes(button)
              }
          });
      });
      observer.observe(button, { attributes: true })
  })
  

  /*
  * 
  * Calendar
  *
  <span placeholder="Dal" data-postcalendar="" class="date-from">Dal</span>
  <span placeholder="Al" data-postcalendar="" class="date-to">al</span>
  <div id="aj-calendar" class="widget widget-calendar"></div>
  */
  

    var calendarLoading = false,
      $ajCalendar = null,
      $fromField = $('[data-postcalendar].date-from'),
      $toField = $('[data-postcalendar].date-to'),
      $activeField = null, //reference al campo attivo
      $dateIntervalSubmit = $('.js-widget-dateinterval .submit'),

      numberPad = function(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
      },

      getCalendarTdByDay = function($calendar, day){
        return $calendar.find('td').not('.pad').filter(function () {
          return (($(this).text() === day) || ($(this).children().text() === day));
        });
      },

      setActiveCell = function(d, activeClass, $calendar){
        if(!$calendar){
          $calendar = $ajCalendar;
        }
        var d_m = numberPad(d.getMonth()+1, 2),
          d_y = d.getFullYear() + '',
          d_d = d.getDate() + '';
        
        var monthnum_str = $calendar.find('.wp-calendar').attr('data-monthnum'),
          year_str = $calendar.find('.wp-calendar').attr('data-year');
  
        if(monthnum_str === d_m && year_str ===d_y){
          
          getCalendarTdByDay($calendar, d_d).addClass(activeClass);
        }
      },

      setActiveCells = function(){
        if($activeField){
          $activeField.addClass('active');
        }

        if($fromField.data('date')){
          setActiveCell($fromField.data('date'), $fromField.data('active-class'));
        }
        if($toField.data('date')){
          setActiveCell($toField.data('date'), $toField.data('active-class'));
        }
      },
      
      closeCalendar = function(e){
        var $clicked = $(e.target);
        if(!$clicked.parents('.js-widget-dateinterval').length){
          hideCalendar();
        }              
      },

      setYearMonth = function($this, ajax_data) {
        if($this.is('[data-calendar-goto]')) {
          var re = /^(\d{4})-(\d{2})$/g, match = re.exec($this.attr('data-calendar-goto'));
          ajax_data.year = match[1];
          ajax_data.monthnum = match[2];
        } else if ($this.attr('href')) {
          var re = /(\d{4})\/(\d{2})\/$/g, match = re.exec($this.attr('href'));
          ajax_data.year = match[1];
          ajax_data.monthnum = match[2];
        }
      },
      
      setCalendar = function(e){
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this), ajax_data = {
          action:'data_load',
          type: 'calendar',
          security: wp_object.ajax_nonce
        };
        
        
        
        if($this.is('[data-postcalendar]')){
          if($activeField){
            $activeField.removeClass('active');
          }
          
          $activeField = $this;
          $ajCalendar = $this.data('ajCalendar');

          $(document).on('click', 'html, body', closeCalendar);
          
          $ajCalendar.attr('class', 'aj-calendar calendar-'+$activeField.data('active-class'));
          
          if($this.data('cache')){
            $ajCalendar.html($this.data('cache'));

            setActiveCells();
            return false;
          }else{
            if($(this).data('date')){
              var d = $(this).data('date');
              ajax_data.year = d.getFullYear();
              ajax_data.monthnum = d.getMonth()+1;
            }
          }
        }else{
          setYearMonth($this, ajax_data)
        }

        if(calendarLoading || !$ajCalendar) {return false;}
        calendarLoading=true;

        if (ajax_data.year) {
          $ajCalendar.getLoad(wp_object.ajax_url, null, ajax_data, function(responseText, textStatus, XMLHttpRequest, items){
            calendarLoading=false;

            //ad ogni click aggiorno la cache del campo attivo
            $activeField.data('cache', responseText);

            setActiveCells();
          });
        }
      },
      
      hideCalendar = function(e){
        $(document).off('click', 'html, body', closeCalendar);
        
        $('.aj-calendar').empty().html(''); //fix per istanze multiple
        $ajCalendar = null;
        
        if($activeField){
          $activeField.removeClass('active');
          $activeField = null;
        }
      },
      setDate = function(e){
        e.preventDefault();
        e.stopPropagation();
        var $td = $(this).parent();
        
        if(!parseInt($(this).text(),10)){
          return false;
        }
        var monthnum_str = $ajCalendar.find('.wp-calendar').attr('data-monthnum'),
          year_str = $ajCalendar.find('.wp-calendar').attr('data-year'),
          day_str = $(this).text(),
          d = new Date(parseInt(year_str,10), parseInt(monthnum_str,10) - 1, parseInt(day_str,10));

        if($activeField){
          $td.parents('.wp-calendar').find('.'+$activeField.data('active-class')).removeClass($activeField.data('active-class'));
          $td.addClass($activeField.data('active-class'));
          $activeField.data('date', d);
          
          updateFieldValue($activeField);
        }

        validateDates();

        setTimeout(hideCalendar, 500);
      },
      dateParts = function(d){
        return [d.getFullYear() + '', numberPad(d.getMonth()+1, 2), numberPad(d.getDate(), 2)];
      },
      updateFieldValue = function($field){
        var d = $field.data('date'),
          parts = dateParts(d);
        $field.find('.value').text(parts[2]+'/'+parts[1]+'/'+parts[0]);
      },
      dateFormatMysql = function(d){
        var parts = dateParts(d);
        return parts[0]+'-'+parts[1]+'-'+parts[2];
      },
      validateDates = function(){
        if($fromField.data('date') && $toField.data('date')){
          $dateIntervalSubmit.addClass('enabled');
          if($toField.data('date') <= $fromField.data('date')){
            var fromDate = $toField.data('date'),
              toDate = $fromField.data('date');
            $fromField.data('date', fromDate);
            $toField.data('date', toDate);

            updateFieldValue($fromField);
            updateFieldValue($toField);
          }
        }else{
          $dateIntervalSubmit.removeClass('enabled');
        }
      },
      submit = function(e){
        e.preventDefault();
        if($fromField.data('date') && $toField.data('date')){
          var fromDate = $fromField.data('date'),
            toDate = $toField.data('date');
    
          location.href= encodeURI(wp_object.home_url+'?dmn='+dateFormatMysql(fromDate)+'&dmx='+dateFormatMysql(toDate));
        }
      },
      
      $widgetCalendarWrapper = $('#widget-calendar .calendar-wrapper'),
      setArchiveCalendar = function(e){
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this), ajax_data = {
          action:'data_load',
          type: 'calendar',
          security: wp_object.ajax_nonce
        };
        
        setYearMonth($this, ajax_data)

        if(calendarLoading) {return false;}
        calendarLoading=true;

        if (ajax_data.year) {
          $widgetCalendarWrapper.getLoad(wp_object.ajax_url, null, ajax_data, function(responseText, textStatus, XMLHttpRequest, items){
            calendarLoading=false;
          });
        }

      };
    
    
    //[data-postcalendar] Data initialization
    $fromField.data('active-class', 'active-from');
    $toField.data('active-class', 'active-to');
    $('[data-postcalendar]').each(function(){
      //reference usata al click
      var $ajCalendar = $(this).closest('.js-widget-dateinterval').find('.aj-calendar');
      $(this).data('ajCalendar', $ajCalendar);
    });
    //[data-postcalendar] Data initialization
    
    $(document).on('click', '[data-postcalendar], .aj-calendar .prev a, .aj-calendar .next a', setCalendar);
    $(document).on('click', '.aj-calendar tbody td:not(.pad)', setDate);
    $dateIntervalSubmit.on('click', submit);
    
    $(document).on('click', '#widget-calendar .prev a, #widget-calendar .next a, [data-calendar-goto]', setArchiveCalendar);
    
    
    //Init fields
    if($('[data-from]').length){
      var parts = $('[data-from]').attr('data-from').split('-');
      var d = new Date(parseInt(parts[0],10), parseInt(parts[1],10) - 1, parseInt(parts[2],10));
      $fromField.data('date', d);
      updateFieldValue($fromField);
      setActiveCell($fromField.data('date'), $fromField.data('active-class'), $('.widget-calendar'));
    }
    if($('[data-to]').length){
      var parts = $('[data-to]').attr('data-to').split('-');
      var d = new Date(parseInt(parts[0],10), parseInt(parts[1],10) - 1, parseInt(parts[2],10));
      $toField.data('date', d);
      updateFieldValue($toField);
      setActiveCell($toField.data('date'), $toField.data('active-class'), $('.widget-calendar'));
    }
    validateDates();
    
    
    
    //CALENDAR ACTIVE DAY
    var $active_day_calendar = $('.wp-calendar[data-day]');
    if($active_day_calendar.length){
      getCalendarTdByDay($active_day_calendar, $active_day_calendar.attr('data-day')).addClass('active-archive');
    }



    /*
    * https://jqueryui.com/tabs/
    * https://api.jqueryui.com/tabs/
    * 
    $('[data-tabs]').tabs({
      active: 0,
      heightStyle: 'content', // 'content'
    });
    */
    /*
    $('[data-tabs] button').on('click', function (event) {
      event.preventDefault()
      $(this).tab('show')
    })
    */

    carouselAction.appInit()

    carousel.init();

    search.init()

    svgInline.init()

    const resizeHandler = function() {
      document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px')
    }
    const resizeHandlerThrottle = throttle(resizeHandler, 200)
    resizeHandler()
    appUtils.$window
      .resize(resizeHandlerThrottle)
}

$(document)
  .on('ready', onDocumentReady)
  .on('click', '[data-menutoggle]', function(e){
    appUtils.setNavigationPanel( $(this).attr('data-menutoggle') )
  });

/*
( function ( $ ){
  $(document).on('ready', onDocumentReady);
} )( jQuery);
*/